<div
  [hidden]="!showDropdown"
  ngbDropdown
  placement="bottom-end"
  class="aa-dropdown ms-2"
>
  <button
    data-dd-action-name="export-button.export-menu-button"
    type="button"
    id="export-button"
    class="btn btn-outline mb-1"
    [class.btn-sm]="size === 'small'"
    ngbDropdownToggle
    [disabled]="disabled"
  >
    <i-lucide name="download"></i-lucide>
    {{ description || 'Export' }}
  </button>

  <div ngbDropdownMenu aria-labelledby="export-button">
    <button
      data-dd-action-name="export-button.export-csv-item-button"
      type="button"
      ngbDropdownItem
      (click)="onExportClick()"
      [trackingEvent]="'Export Grid  - CSV'"
    >
      As CSV
    </button>

    <ng-content></ng-content>
  </div>
</div>

@if (!showDropdown) {
  <button
    data-dd-action-name="export-button.export-csv-button"
    type="button"
    id="export-csv-button"
    class="btn btn-outline mb-1 ms-2"
    [class.btn-sm]="size === 'small'"
    [disabled]="disabled"
    (click)="onExportClick()"
    [trackingEvent]="'Export Grid  - CSV'"
  >
    <i-lucide name="download"></i-lucide>
    {{ description || 'Export CSV' }}
  </button>
}
